
const workercode = () => {
    onmessage = function (x) {
        let { timerMin, timerSec, breakMin } = x.data;

        let i = 1000;
        let e = Date.now() + i;
        setTimeout(timer, i);

        function timer() {
            let d = Date.now() - e;
            if (d > i) { }
            e += i;
            if (timerSec - 1 === -1) {
                if (timerMin - 1 === - 1) {
                    if (breakMin === 0) {
                        postMessage({
                            timerMin: 0,
                            timerSec: 0,
                            playAudio: true,
                            status : 'DONE'
                        });
                    } else {
                        timerSec = 0;
                        timerMin = breakMin;
                        breakMin = 0;
                        postMessage({
                            timerMin: 0,
                            timerSec: 0,
                            playAudio: true,
                            status : 'BREAK'
                        });
                    }
                } else {
                    timerSec = 59;
                    timerMin -= 1;
                    postMessage({
                        timerMin: timerMin,
                        timerSec: timerSec,
                        playAudio: false,
                        status : 'STANDARD'
                    });
                }
            } else {
                timerSec -= 1;
                postMessage({
                    timerMin: timerMin,
                    timerSec: timerSec,
                    playAudio: false,
                    status : 'STANDARD'
                });
            }
            setTimeout(timer, Math.max(0, i - d));
        }

    }
};


let code = workercode.toString();
code = code.substring(code.indexOf("{") + 1, code.lastIndexOf("}"));
const blob = new Blob([code], { type: "application/javascript" });
const worker_script = URL.createObjectURL(blob);

module.exports = worker_script;